import Axios, { AxiosRequestConfig } from 'axios';
import env from '../env';
import { Response } from '../types/Response';
import { sbxEventValidator } from 'src/classes/SbxEvent';

const http = Axios.create({
    baseURL: env.baseUrl,
    timeout: 300000,
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(env.token_key) || process.env.REACT_APP_TOKEN}`,
    },
});

http.interceptors.response.use((response) => {
    return new Response<any>(response) as any;
});

http.interceptors.request.use((req) => {
  sbxEventValidator(req);
  return req;
});

const request = {
    GET: <Data>(pathname: string, config?: AxiosRequestConfig): Promise<Response<Data>> => http.get(pathname, config).then(res => res).catch(err => err),
    POST: <Data>(pathname: string, data: any, config?: AxiosRequestConfig): Promise<Response<Data>> =>
        http.post(pathname, data, config).then(res => res).catch(err => err),
    PUT: <Data>(pathname: string, data: any, config?: AxiosRequestConfig): Promise<Response<Data>> =>
        http.put(pathname, data, config).then(res => res).catch(err => err),
    DELETE: <Data>(pathname: string, config?: AxiosRequestConfig): Promise<Response<Data>> =>
        http.delete(pathname, config).then(res => res).catch(err => err),
};

export default request;
